import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import React, { BaseSyntheticEvent, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { chevronBackOutline } from 'ionicons/icons'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { getZipSelector } from '../../../components/zip/selectors/zip.selector'
import PatientInformationContent from '../paymentInformationContent/paymentInformation.content'
import { savePaymentInformation } from '../store/paymentInformation.actions'

const PaymentInformation: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const zip = useSelector(getZipSelector)
  const { alertMessage } = zip

  const history = useHistory()

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.BILLING)
  }

  const saveOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch(savePaymentInformation())
  }

  useEffect(() => {
    if (alertMessage) {
      dispatch(showAlert({ message: alertMessage }))
    }
  }, [dispatch, alertMessage])

  return (
    <IonPage id='PaymentInformationPage'>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton data-testid='Save' color='primary-alt' fill='clear' onClick={saveOnClick}>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
          <IonTitle data-testid='HeaderTitle'>{t('fullChart.patient.billing.PaymentInformation')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent id='main-pn-content' color='light' fullscreen>
        <PatientInformationContent />
      </IonContent>
    </IonPage>
  )
}

export default PaymentInformation
